import React from "react";

type KPIProps = {
  label: string;
  value: React.ReactNode; // can be string, number, JSX, etc.
};

function KPI({ label, value }: KPIProps) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white/90 p-4 shadow-sm">
      <div className="absolute -right-6 -top-8 h-16 w-16 rounded-full bg-indigo-200 opacity-40" />
      <div className="text-xs font-medium uppercase tracking-wide text-slate-500">
        {label}
      </div>
      <div className="mt-2 text-2xl font-semibold text-slate-900">{value}</div>
    </div>
  );
}

export { KPI };
